/*
 * The Private License
 *
 * Copyright (c) 2023 Mahon Media LLC.
 */

import { useNotification } from "../contexts/NotificationContext";
import { Alert, Snackbar } from "@mui/material";
import React from "react";

export default function Notification() {
  const { isOpen, setIsOpen, isFailed, message } = useNotification();

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={() => setIsOpen(false)}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Alert
        onClose={() => setIsOpen(false)}
        severity={isFailed ? "error" : "success"}
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
